var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    strokeWidth: 1.5,
    d: "m9.672 3.476-5.374 9.308a6.187 6.187 0 1 0 10.717 6.187l5.327-9.227a4.125 4.125 0 0 0-7.144-4.125L7.87 14.846a2.062 2.062 0 0 0 3.573 2.063l5.156-8.931"
  })));
};
export default SvgAttachment;